import { request } from '@/request/request';
import { parameterChange } from '@/utils';

const prefix = `${process.env.VUE_APP_OU_PREFIX}/client_release`;

// 新版 H5 放量配置（仅超级管理员）
export default {
  clientReleaseDetail() {
    return request({ url: `${prefix}/detail`, method: 'get' });
  },
  clientReleaseUpdate(data) {
    return request({ url: `${prefix}/update`, method: 'post', data });
  },
  clientReleaseEmergencyOff(data) {
    return request({ url: `${prefix}/emergencyOff`, method: 'post', data });
  },
  clientReleaseLogPageList(data) {
    return request({ url: `${prefix}/logPageList?${parameterChange(data)}`, method: 'get', data });
  },
  clientReleaseCheck(data) {
    return request({ url: `${prefix}/check?${parameterChange(data)}`, method: 'get', data });
  },
};
